import React, { useState } from 'react';
import { partners, partnerCategories } from '../data/partners';
import '../styles/Partners.css';

const PartnersSection = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");

  const filteredPartners = selectedCategory === "all" 
    ? partners 
    : partners.filter(partner => {
        if (selectedCategory === "Fire Safety") {
          return partner.category === "Fire Safety" || partner.name === "Honeywell";
        }
        if (selectedCategory === "Building Management") {
          return partner.category === "Video Surveillance & IoT" || partner.name === "Honeywell";
        }
         if (selectedCategory === "Video Surveillance & IoT") {
          return partner.category === " Video Surveillance & IoT" || partner.name === "Honeywell";
        }
       
        
        return partner.category.toLowerCase().includes(selectedCategory.toLowerCase());
      });

  return (
    <section id="partners" className="partners-section">
      <div className="partners-container">
        <div className="partners-header">
          <h2 id="partners-title-html" className="partners-title">Trusted Technology Partners</h2>
          <p className="partners-subtitle">
            Strategic partnerships with leading technology providers to deliver comprehensive solutions
          </p>
        </div>

        <div className="partners-filter">
          <h3 className="filter-title">Technology Categories</h3>
          <div className="filter-chips">
            <button 
              className={`filter-chip ${selectedCategory === "all" ? "active" : ""}`}
              onClick={() => setSelectedCategory("all")}
            >
              All Partners
            </button>
            {partnerCategories.map((category, index) => (
              <button
                key={index}
                className={`filter-chip ${selectedCategory === category.name ? "active" : ""}`}
                onClick={() => setSelectedCategory(category.name)}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>
        </div>

        <div className="partners-grid">
          {filteredPartners.map((partner, index) => {
            const CardContent = (
              <>
                <div className="partner-logo-container">
                  <img src={partner.icon} alt={partner.name} className="partner-logo" loading="lazy" />
                </div>
                <h4 className="partner-name">{partner.name}</h4>
                <p className="partner-category">{partner.category}</p>
                <div className="partner-specialties">
                  {partner.specialties.map((specialty, idx) => (
                    <span key={idx} className="specialty-chip">{specialty}</span>
                  ))}
                </div>
              </>
            );
            return partner.url ? (
              <a key={index} href={partner.url} className="partner-card" style={{'--partner-color': partner.color}} target="_blank" rel="noopener noreferrer">
                {CardContent}
              </a>
            ) : (
              <div key={index} className="partner-card" style={{'--partner-color': partner.color}}>
                {CardContent}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
